import { useCallback, useEffect, useRef } from 'react';
import { useAppSelector } from 'store/hooks';
import Modal from 'utils/packages/Modal';
import { selectHasFailedPayment } from '../selectors';
import useFailedPayment from './useFailedPayment';
const strings = {
    title: 'Your last payment didn\u2019t go through',
    subtitle: 'To switch your plan, you\u2019ll need to clear your outstanding balance.',
    seatSubtitle: 'To add extra member slots, you\u2019ll need to clear your outstanding balance.',
    confirmButtonTitle: 'Update payment method',
};
const useFailedPaymentModal = () => {
    const hasFailedPayment = useAppSelector(selectHasFailedPayment);
    const { paymentFailed, onPressUpdatePayment, modalSubtitleText, changingPaymentMethod, } = useFailedPayment();
    const { onPressUpdatePayment: onPressUpdateSeatBasedPayment, modalSubtitleText: seatBasedModalSubtitleText, changingPaymentMethod: changingSeatBasedPaymentMethod, } = useFailedPayment({ seatBased: true });
    const pendingCallback = useRef(null);
    useEffect(() => {
        if (!hasFailedPayment && pendingCallback.current) {
            const callback = pendingCallback.current;
            pendingCallback.current = null;
            callback();
        }
    }, [hasFailedPayment]);
    const showFailedPaymentModal = useCallback((onResolved, subtitleOverride) => {
        if (!hasFailedPayment)
            return false;
        const isMainSub = !!paymentFailed;
        const onConfirm = isMainSub
            ? onPressUpdatePayment
            : onPressUpdateSeatBasedPayment;
        pendingCallback.current = onResolved ?? null;
        const activeSubtitleText = isMainSub
            ? modalSubtitleText
            : seatBasedModalSubtitleText;
        const clearPendingCallback = () => {
            pendingCallback.current = null;
        };
        Modal.showConfirmation({
            title: strings.title,
            subtitle: [
                subtitleOverride ??
                    (isMainSub ? strings.subtitle : strings.seatSubtitle),
                activeSubtitleText,
            ],
            confirmButtonTitle: strings.confirmButtonTitle,
            onConfirm,
            onPressCancel: clearPendingCallback,
            onBackdropPress: clearPendingCallback,
            onSwipeComplete: clearPendingCallback,
        });
        return true;
    }, [
        hasFailedPayment,
        paymentFailed,
        onPressUpdatePayment,
        modalSubtitleText,
        seatBasedModalSubtitleText,
        onPressUpdateSeatBasedPayment,
    ]);
    return {
        paymentFailed: hasFailedPayment,
        showFailedPaymentModal,
        isFetching: changingPaymentMethod || changingSeatBasedPaymentMethod,
    };
};
export default useFailedPaymentModal;
